import React from "react";
import Select from "react-select";
import { VMBuilder } from "../../commons/base/providers/builder";
import { SoldOutCaseKindEnum } from "../models/sold_out_case_kind_enum";
import SoldOutCmsEditorViewModel from "../view_models/sold_out_cms_editor_view_model";

export default class SoldOutCmsModalWidget extends React.Component {
    render(): React.ReactNode {
        return (
            <VMBuilder<SoldOutCmsEditorViewModel>>
                {(vm) => (
                    <div
                        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 max-h-screen p-2"
                        onClick={() => vm.closeModal()}
                    >
                        <div
                            className="relative bg-white rounded-lg shadow-lg mt-10 pt-5 px-5 w-full max-w-3xl max-h-[83vh] overflow-y-auto"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <h2 className="text-2xl font-bold mb-4">
                                {vm.isCaseOptionDisabled
                                    ? "Update"
                                    : "Tambahkan Case Baru"}
                            </h2>

                            {/* Tipe Case */}
                            {!vm.isCaseOptionDisabled && (
                                <>
                                    <label>Tipe Case</label>
                                    <Select<{
                                        label: string;
                                        value: SoldOutCaseKindEnum;
                                    }>
                                        placeholder="Pilih Tipe Case"
                                        className="m-2"
                                        options={Object.values(
                                            SoldOutCaseKindEnum
                                        ).map((type) => ({
                                            label: type,
                                            value: type,
                                        }))}
                                        onChange={(option) => {
                                            if (option) {
                                                vm.updateSelectedCaseType(
                                                    option.value
                                                );
                                            }
                                        }}
                                        value={
                                            Object.values(SoldOutCaseKindEnum)
                                                .filter(
                                                    (type) =>
                                                        type ===
                                                        vm.selectedCaseType
                                                )
                                                .map((type) => ({
                                                    label: type,
                                                    value: type,
                                                }))[0] ?? null
                                        }
                                    />
                                </>
                            )}

                            {/* {!vm.isCaseOptionDisabled && ( */}
                                <>
                                    {/* Nama Case */}
                                    {/* <label htmlFor="">Nama Case</label>
                                    <Select
                                        placeholder="Pilih Case"
                                        className="m-2"
                                        options={vm.shownCaseOptions}
                                        onChange={(option) => {
                                            if (option) {
                                                vm.updateSelectedCaseId(
                                                    option.value
                                                );
                                            }
                                        }}
                                        isDisabled={vm.isCaseOptionDisabled}
                                        value={ */}
                                            {/* // vm.shownCaseOptions.filter(
                                            //     (option) =>
                                            //         option.value ===
                                            //         vm.selectedCaseId
                                            // )[0] ?? null
                                            () => {
                                                if (vm.selectedCaseId) {
                                                    return vm.shownCaseOptions.filter(
                                                        (option) =>
                                                            option.value === parseInt(vm.selectedCaseId!)
                                                    // TODO: should show error becase selected
                                                    )[0] ?? null
                                                }
                                                return null;
                                            }
                                        } */}
                                    {/* /> */}
                                </>
                            {/* )} */}

                            {/* Affected menu table */}
                            <div className="overflow-x-auto">
                                <table className="table-auto w-full text-center border-collapse my-2">
                                    <thead>
                                        <tr className="bg-gray-300">
                                            <th className="p-2 border border-gray-400 w-1/2">
                                                Menu Id
                                            </th>
                                            <th className="p-2 border border-gray-400 w-1/2">
                                                Menu
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {vm.selectedAffectedMenuIds.map(
                                            (menuId, index) => (
                                                <tr
                                                    key={index}
                                                    className="bg-white"
                                                >
                                                    <td className="p-2 border border-gray-400">
                                                        {menuId}
                                                    </td>
                                                    <td className="p-2 border border-gray-400">
                                                        {vm.menuMap.get(menuId)
                                                            ?.title ?? ""}
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Add Affected Menu & Submit */}
                            <div className="mt-6 sticky bottom-0 bg-white px-4 py-6 shadow-inner">
                                <div className="w-full flex space-x-4 items-center">
                                    <div className="flex-grow">
                                        <Select
                                            placeholder="Tambah Item ?"
                                            className="basic-single w-full"
                                            classNamePrefix="select"
                                            isClearable
                                            isSearchable
                                            name="item"
                                            options={[
                                                ...vm.menuMap.values(),
                                            ].map((model) => ({
                                                label: model.title,
                                                value: model.id,
                                            }))}
                                            onChange={(selectedOption) => {
                                                if (selectedOption) {
                                                    vm.updateSelectedNewMenuId(
                                                        selectedOption.value
                                                    );
                                                }
                                            }}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                            }}
                                        />
                                    </div>

                                    <button
                                        onClick={() => {
                                            if (vm.selectedNewMenuId) {
                                                vm.handleAddNewSelectedMenuId(
                                                    vm.selectedNewMenuId
                                                );
                                            }
                                        }}
                                        className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 disabled:bg-gray-500"
                                        disabled={!vm.selectedNewMenuId}
                                    >
                                        Masukkan
                                    </button>
                                </div>
                                <div className="mt-4">
                                    <button
                                        className="bg-green-500 disabled:bg-gray-400 text-white px-6 py-2 rounded-lg hover:bg-green-600 w-full"
                                        onClick={() => vm.submitData()}
                                    >
                                        Simpan Data
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </VMBuilder>
        );
    }
}
